import type { FaireProductEntity } from "../../entity_types/product";

export const p_x48qh3swd5: FaireProductEntity = {
  token: "p_x48qh3swd5",
  type: "product",
  name: "Soothing Face Mist - Relax",
  brandToken: "b_5nhxjdyopf",
  brandName: "Natural Outcome Skincare",
  imageUrl: "https://cdn.faire.com/fastly/d304ff7e864f85a021ced7a6df8c632f4dd08f288480146eb6345f7211be7b11.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9f75e15786fae391fa5cafa769cb0f1f8a37a38cb17c3125b78e48e7f65e65c4.png",
    "https://cdn.faire.com/fastly/b80301eb7fd07cad85b5db755191c92ccf57cdf8e99b7945c4907ede82a09e04.png",
    "https://cdn.faire.com/fastly/b3fa2be0c6bba7884c74d8c595ed7b69872b2ff68104bf264d7266fcffee25bd.png",
    "https://cdn.faire.com/fastly/bdc7953dd7727605f6a45421c7ec875915280dfec0c0096b4d003d7b5400a5c8.png"
  ],
  priceDollars: 4.97,
  description: "Soothing & Calming Face Spray\nUse for skin hydration, aromatherapy & makeup setting\nRelaxes skin stress with natural Lavender Oil.",
  tags: [],
  msrpDollars: 9.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:09.384Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
